import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

// Reusable FAQ accordion. Pass `faqs` as an array of { q, a }.
// The entire header row (question + chevron) is clickable, only one
// answer is open at a time, and it animates smoothly on toggle.
export default function FaqAccordion({ faqs }) {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="faq-list">
      {faqs.map((faq, i) => {
        const isOpen = openIndex === i;
        return (
          <div key={faq.q} className={`faq-item${isOpen ? ' open' : ''}`}>
            <button
              type="button"
              className="faq-question-btn"
              onClick={() => setOpenIndex(isOpen ? null : i)}
              aria-expanded={isOpen}
            >
              <span className="faq-question-text">{faq.q}</span>
              <ChevronDown size={18} className="faq-chevron" />
            </button>
            <div className="faq-answer-wrap">
              <div className="faq-answer-inner">
                <p className="faq-answer">{faq.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
